import React, {Component} from 'react'
import PropTypes from 'prop-types'

class ProductType extends Component {
    _onClickType = (value) => {
        const {onChangeProductType} = this.props

        if (typeof onChangeProductType === 'function') {
            onChangeProductType(value)
        }
    }

    render() {
        const {types, brand, handleChangeInput} = this.props
        const newBrand = (Array.isArray(brand) && !!brand.length && brand) ? brand.filter(b => !!b) : brand

        return (
            <td className="ProductType">
                {
                    types !== undefined && types.map((type, index) => {
                        return type !== null &&
                            <span key={index} className="mr-2" onClick={() => this._onClickType([type])}>{type}</span>
                    })
                }
                {
                    Array.isArray(newBrand) ?
                        newBrand.map(b => (
                            <div className='Brand'>
                                <span className="mr-2" onClick={() => handleChangeInput('brand', [b])}>{b}</span>
                            </div>
                        )) :
                        !!newBrand ?
                            <div className='Brand'>
                                <span className="mr-2" onClick={() => handleChangeInput('brand', [newBrand])}>{newBrand}</span>
                            </div> : ''
                }
            </td>
        )
    }
}

ProductType.propTypes = {
    types: PropTypes.array,
    onChangeProductType: PropTypes.func
}

export default ProductType